import { PromotionReward } from '@bonanza-social/promos';
import {
  rewardBadgeMap,
  rewardNamesMap,
} from './InviteFriendsRewards.constants';
import {
  Box,
  Breakpoint,
  formatAmount,
  Icon,
  Text,
  useBreakpoint,
} from '@bonanza-social/moonlight';
import { formatCompact } from '@bonanza-social/toolkit/utils';
import { useTranslation } from '@bonanza-social/i18n';

type RewardLineProps = {
  reward: PromotionReward;
  suffix?: string;
};

function RewardLine({ reward, suffix }: RewardLineProps) {
  const { t } = useTranslation('inviteFriends');
  const iconName = rewardBadgeMap[reward.rewardTarget] ?? 'freeSpins';
  const amount = reward.freeSpinsBetAmount
    ? t('betAmountTemplate', {
        amount: formatAmount(reward.freeSpinsBetAmount),
      })
    : '';
  const breakpoint = useBreakpoint();
  const fontVariant = Breakpoint.MOBILE === breakpoint ? 'body-s-semi' : 'h6';

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      flexWrap="wrap"
      marginVertical="space-100"
    >
      <Icon
        name={iconName}
        gradient="accentBackground"
        height={20}
        width={20}
        marginRight="space-100"
      />
      <Text variant={fontVariant} gradient="darkSurfaceAccent">
        {formatCompact(reward.rewardAmount)}{' '}
      </Text>
      <Text
        variant={fontVariant}
        gradient="darkSurfaceAccent"
        locNS="common"
        locKey={rewardNamesMap[reward.rewardTarget]}
      />
      {amount ? (
        <Text variant={fontVariant} gradient="darkSurfaceAccent">
          {' '}
          {amount}
        </Text>
      ) : null}
      {suffix ? (
        <Text variant={fontVariant} gradient="darkSurfaceAccent">
          {' '}
          {suffix}
        </Text>
      ) : null}
    </Box>
  );
}

export default RewardLine;
